import script from "./salesPerson.vue?vue&type=script&setup=true&lang=js"
export * from "./salesPerson.vue?vue&type=script&setup=true&lang=js"

import "./salesPerson.vue?vue&type=style&index=0&id=37f8f6e9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f8f6e9"]])

export default __exports__